import * as S from '@effect/schema/Schema';
import * as t from 'io-ts';
export var WishlistItem = t.type({
  id: t.string,
  progress: t.number,
  title: t.string
});
export var getWishlistQueryCodec = t.type({
  wishlist: t.array(WishlistItem)
});
export var WishlistBlockConfig = S.struct({
  typename: S.literal('WishlistBlock'),
  id: S.string,
  hash: S.string
});